module.exports = __webpack_public_path__ + "static/media/LogoMails.49a0152c.png";